var _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6, _rect3, _path7, _rect4, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyFilterDataset = function SvgEmptyFilterDataset(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 84,
    viewBox: "0 0 79 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 84C55.7288 84 49 77.2712 49 69C49 60.7288 55.7288 54 64 54C72.2712 54 79 60.7288 79 69C79 77.2712 72.2712 84 64 84Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76V69V62M57 69H71",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10Z",
    fill: "#6366F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02734 6.40706L6.22393 7.47947L8.10912 5.30078",
    stroke: "white",
    strokeWidth: 0.54341,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 28C8.433 28 10 26.433 10 24.5C10 22.567 8.433 21 6.5 21C4.567 21 3 22.567 3 24.5C3 26.433 4.567 28 6.5 28Z",
    fill: "#6366F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02734 24.4071L6.22393 25.4795L8.10912 23.3008",
    stroke: "white",
    strokeWidth: 0.54341,
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 44C7.32843 44 8 43.3284 8 42.5C8 41.6716 7.32843 41 6.5 41C5.67157 41 5 41.6716 5 42.5C5 43.3284 5.67157 44 6.5 44Z",
    fill: "#6366F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 54,
    width: 44,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 62C7.32843 62 8 61.3284 8 60.5C8 59.6716 7.32843 59 6.5 59C5.67157 59 5 59.6716 5 60.5C5 61.3284 5.67157 62 6.5 62Z",
    fill: "#6366F1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyFilterDataset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-filter-dataset.210241b65fde2598959a3988c0c4270b.svg";